import api from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async submitResponse({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.post("v2/guest/consultation-survey", payload);
        dispatch("handleResponse", res);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },
    handleResponse({ commit, dispatch }, res) {
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        throw res.status;
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      }
    },
  },
};
